import React from "react";
import { Logo } from "components";
import useForm from "../../hooks/validation/useForm";
import { validateEmail } from "../../components/utils/validationUtils";
import { usePasswordReset } from "hooks";
import { Flex, Text, Button, Link, TextField } from "@radix-ui/themes";
import * as Form from "@radix-ui/react-form";

export default function Resetpassword() {
  
  const initialFormState = {
    email: "",
  };

  const {
    mutate: passwordReset, 
    isSuccess: isSuccessMailSent,
    isPending,
    isError,
    error
  } = usePasswordReset();

  const validations = {
    email: (value) =>
      !value
        ? "Input your email address."
        : !validateEmail(value)
          ? "Invalid email address."
          : "",
  };

  const { formState, errors, handleChange, handleSubmit } = useForm(
    initialFormState,
    validations
  );

  const handleEmailSend = async (formState) => {
    passwordReset(formState);
    
  };

  return (
    <Flex style={{ height: '100vh', width: '100vw'}}>
      {/* Forgot your password section */}
      <Flex direction="column" align="stretch" px="7" py="8" style={{alignItems: 'center', flex: '1 1 50%',}}>
        <Flex justify="center" align="stretch" width="100%" style={{alignItems: 'center', flex: '1 0 0'}}>
          <Flex direction="column" gap="7" maxWidth="296px" style={{alignSelf: 'stretch', alignItems: 'center',
            justifyContent: 'center', flex: '1 0 0'}}>
            <Text size="4" weight="bold" align="center">Forgot Your Password</Text>
            {!isSuccessMailSent ? (
              <Form.Root onSubmit={(e) => handleSubmit(e, handleEmailSend)} style={{width: '100%'}}>
                <Flex direction="column" gap="5" style={{alignItems: 'flex-start', alignSelf: 'stretch'}}>
                  <Form.Field name="email" style={{width: '100%'}}>
                    <Form.Label style={{display: 'flex', flexDirection: 'column', marginBottom: '4px'}}>
                      <Text size="2" weight="medium">Email address</Text>
                    </Form.Label>
                    <Form.Control asChild>
                      <TextField.Root
                        name="email"
                        type="email"
                        size="2"
                        placeholder='example@email.com'
                        value={formState.email}
                        onChange={handleChange}
                      />
                    </Form.Control>
                    {errors.email && (
                      <Form.Message>
                        <Text size="1" weight="regular" color="red">{errors.email}</Text>
                      </Form.Message>
                    )}
                    {/* Server-side email error */}
                    {isError && error?.response?.data?.email && (
                      <Form.Message>
                        <Text size="1" weight="regular" color="red">
                          {error.response.data.email[0]}
                        </Text>
                      </Form.Message>
                    )}
                  </Form.Field>
                  <Flex direction="column" style={{alignItems: 'flex-start', alignSelf: 'stretch'}}>
                    <Button type="submit" variant="solid" radius="medium"
                      loading={isPending}
                      style={{alignSelf: 'stretch'}}>
                      Send password reset email
                    </Button>
                  </Flex>
                </Flex>
              </Form.Root>
            ) : (
              <Flex direction="column" gap="2" style={{ alignSelf: 'stretch' }}>
                <Text size="3" weight="medium" align="center">Password reset email sent!</Text>
                <Text size="2" align="center">Check your inbox and follow the instructions to reset your password.</Text>
                <Text size="2" align="center">You can close this page now.</Text>
              </Flex>
            )}
          </Flex>
        </Flex>
        <Flex gap="7" justify="center" width="100%">
          <Link size="1" weight="regular" color="gray" href="https://b-connect.co.uk/terms" target="_blank">Terms</Link>
          <Link size="1" weight="regular" color="gray" href="https://b-connect.co.uk/privacy" target="_blank">Privacy Policy</Link>
          <Link size="1" weight="regular" color="gray" href="mailto:support@b-connect.co.uk">Support</Link>
        </Flex>
      </Flex>
      {/* Background Image and  Logo Section */}
      <Flex direction="column" align="stretch" style={{ padding: '80px 120px 0 120px', flex: '1 1 50%', 
        alignItems: 'center', background: 'url(/LoginPageBG.png) no-repeat center center / cover',
        backgroundBlendMode: 'soft-light'}}>
        <Logo icon="LogoBWifi" width="40px" height="32px" color="white"/>
      </Flex>
    </Flex>
  );
}
